export const FETCH_INFO = 'fetch_info';
export const FETCH_SERVICE = 'fetch_service';
export const FETCH_ANWALT = 'fetch_anwalt';
export const FETCH_DOWNLOADS = 'fetch_downloads';
export const FETCH_DATENSCHUTZ = 'fetch_datenschutz';
export const FETCH_IMPRESSUM = "fetch_impressum";
export const FETCH_AKTUELLES = 'fetch_aktuelles';
